/*
 * Clamps quantity inputs to their allowed min/max while the user is
 * still typing, instead of only on blur/submit via native validation.
 */
document.addEventListener('input', function (event) {
  const input = event.target;
  if (!input.matches('.quantity__input')) return;
  if (input.value === '' || input.value === '-') return;

  const min = input.hasAttribute('min') ? parseInt(input.min, 10) : null;
  const max = input.hasAttribute('max') ? parseInt(input.max, 10) : null;
  const value = parseInt(input.value, 10);

  if (isNaN(value)) return;

  if (min !== null && value < min) {
    input.value = min;
  } else if (max !== null && value > max) {
    input.value = max;
  }
});
